module.exports = __webpack_public_path__ + "static/img/lb6.beb9fca9.png";